"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _reactMultiDatePicker = _interopRequireDefault(require("react-multi-date-picker"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Text = _interopRequireDefault(require("../Text/Text"));

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _excluded = ["date", "label", "helperText", "error", "onDateChange", "onDateError", "minDate", "maxDate", "iconColor"];

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "DatePicker2__Wrapper",
  componentId: "sc-uhilo9-0"
})(["div{position:relative;}input{width:100%;padding:20px 16px 6px;caret-color:", ";font-family:", ";font-size:", "px;font-weight:400;color:", ";line-height:1.75;letter-spacing:0.009375em;border:2px solid ", ";border-radius:10px;&:hover{border:2px solid ", ";background-color:", ";}&:focus{background-color:", ";}background-color:", ";outline:0;margin-bottom:1px;}label{color:", ";font-family:", ";left:16px;right:auto;top:18px;pointer-events:none;position:absolute;line-height:1.15rem;transition:0.15s;transform:translateY(-60%) translateX(-15%) scale(0.75);}#DatePickerIcon{right:16px;left:auto;top:45%;pointer-events:none;position:absolute;transition:0.15s;transform:translateY(-45%) translateX(-15%) scale(1);}"], function (_ref) {
  var theme = _ref.theme,
      error = _ref.error;
  return error ? theme.colors.error[0] : theme.colors.primary[0];
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.fonts.sansSerif;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.fontSizes[4];
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.dark[1];
}, function (_ref5) {
  var theme = _ref5.theme,
      error = _ref5.error;
  return error ? theme.colors.error[0] : "rgba(99, 152, 195, 1)";
}, function (_ref6) {
  var theme = _ref6.theme,
      error = _ref6.error;
  return error ? theme.colors.error[0] : "rgba(99, 152, 195, 1)";
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.colors.dark[6];
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.colors.dark[5];
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.colors.dark[7];
}, function (_ref10) {
  var theme = _ref10.theme,
      error = _ref10.error;
  return error ? theme.colors.error[0] : theme.colors.dark[2];
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.fonts.sansSerif;
});

var DEFAULT_FORMAT = "DD/MM/YYYY"; // const validateDate = date => {
//   if (!date) return false
//   const dateRegex = /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{4})$/
//   return dateRegex.test(date)
// }

var CustomInput = function CustomInput(_ref12) {
  var openCalendar = _ref12.openCalendar,
      value = _ref12.value,
      iconColor = _ref12.iconColor,
      handleValueChange = _ref12.handleValueChange,
      label = _ref12.label,
      validate = _ref12.validate;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
    onFocus: openCalendar,
    value: value,
    onChange: function onChange(event) {
      validate(event.target.value);
      return handleValueChange(event);
    },
    placeholder: DEFAULT_FORMAT
  }), /*#__PURE__*/_react["default"].createElement("label", null, label), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    id: "DatePickerIcon",
    name: "date_range",
    color: iconColor
  }));
};

var DatePicker2 = function DatePicker2(_ref13) {
  var date = _ref13.date,
      label = _ref13.label,
      helperText = _ref13.helperText,
      error = _ref13.error,
      onDateChange = _ref13.onDateChange,
      onDateError = _ref13.onDateError,
      minDate = _ref13.minDate,
      maxDate = _ref13.maxDate,
      _ref13$iconColor = _ref13.iconColor,
      iconColor = _ref13$iconColor === void 0 ? "dark.2" : _ref13$iconColor,
      props = (0, _objectWithoutPropertiesLoose2["default"])(_ref13, _excluded);
  // const [errorState, setErrorState] = useState(error)
  // const [dateState, setDateState] = useState(date)
  // const [manualInputTouched, setManualInputTouched] = useState(false)
  // useEffect(() => {
  //   // Forcing the component to return null if the date is invalid
  //   if (!manualInputTouched || !errorState) {
  //     onDateChange(dateState.date, null)
  //   } else if (errorState) {
  //     onDateChange(null, errorState)
  //   }
  //   setManualInputTouched(false)
  // }, [dateState])
  // useEffect(() => {
  //   if (enableReinitialize) {
  //     setDateState({ date })
  //   }
  // }, [date])
  return /*#__PURE__*/_react["default"].createElement(Wrapper, null, /*#__PURE__*/_react["default"].createElement(_reactMultiDatePicker["default"], (0, _extends2["default"])({
    value: date,
    format: DEFAULT_FORMAT,
    render: /*#__PURE__*/_react["default"].createElement(CustomInput, {
      label: label,
      iconColor: iconColor // validate={dateString => {
      // setManualInputTouched(true)
      // setErrorState(validateDate(dateString) ? "" : "invalid date")
      // }}

    }),
    onChange: function onChange(value) {
      onDateChange(value == null ? void 0 : value.toDate());
    },
    minDate: minDate,
    maxDate: maxDate
  }, props)), /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    width: "inherit",
    height: 19,
    justifyContent: "space-between"
  }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
    color: error ? "error.0" : "dark.2",
    fontSize: 2,
    pl: 3
  }, error || helperText)));
};

var _default = DatePicker2;
exports["default"] = _default;